import type { Locale } from "date-fns";

import { add } from "date-fns/add";
import { eachDayOfInterval } from "date-fns/eachDayOfInterval";
import { endOfWeek } from "date-fns/endOfWeek";
import { format } from "date-fns/format";
import { getMonth } from "date-fns/getMonth";
import { de, enUS, es, fr, it, pt, zhCN } from "date-fns/locale";
import { startOfMonth } from "date-fns/startOfMonth";
import { startOfWeek } from "date-fns/startOfWeek";

import type { Day, Week } from "./calendar.types";

import { Language } from "../../utils/enums";
import { Days } from "./calendar.enums";

export function getDateFnsLocale(language: Language): Locale {
  switch (language) {
    case Language.German:
      return de;
    case Language.French:
      return fr;
    case Language.Spanish:
      return es;
    case Language.Italian:
      return it;
    case Language.Portuguese:
      return pt;
    case Language.Chinese:
      return zhCN;
    case Language.English:
    default:
      return enUS;
  }
}

type WeekDays = {
  id: string;
  day: string;
};

export function getWeekDays(firstDayOfWeek: Days, locale: Locale): Array<WeekDays> {
  const now = new Date();
  const weekDays: Array<WeekDays> = [];
  const start = startOfWeek(now, {
    weekStartsOn: firstDayOfWeek,
  });
  const end = endOfWeek(now, {
    weekStartsOn: firstDayOfWeek,
  });
  eachDayOfInterval({ start, end }).forEach((day) => {
    weekDays.push({
      id: `${Math.random()}`,
      day: format(day, "EEEEEE", {
        locale,
      }),
    });
  });
  return weekDays;
}

export function getWeeksOfMonth(firstDayOfWeek: Days = Days.Monday, startingDay: Date = new Date()) {
  const currentMonth = getMonth(startingDay);
  const beginningOfMonth = startOfMonth(startingDay);
  const currentWeekStart = startOfWeek(beginningOfMonth, {
    weekStartsOn: firstDayOfWeek,
  });

  let currentDay = currentWeekStart;
  let done = false;

  const weeks: Array<Week> = [];

  while (!done) {
    const currentWeek: Array<Day> = [];
    for (let i = 1; i <= 7; i += 1) {
      currentWeek.push({
        id: `${Math.random()}`,
        day: currentDay,
      });
      currentDay = add(currentDay, {
        days: 1,
      });
    }
    weeks.push({
      id: `${Math.random()}`,
      week: currentWeek,
    });

    if (getMonth(currentDay) !== currentMonth) {
      done = true;
    }
  }

  return weeks;
}
